import { palettes } from '@indigo-ag/component-module';
import React from 'react';
import styled from 'styled-components';
import { getConditionalText } from 'shared';
import { baseTagStyles } from '../tag.styles';
import TagCloseButton from '../TagCloseButton';
import { WithConditionalTooltip } from 'shared';

const FLAGGED_COLOR = '#483d8b';
const UNFLAGGED_COLOR = '#8b4513';

const getTagColor = (flagged?: boolean) => (flagged ? FLAGGED_COLOR : UNFLAGGED_COLOR);

const StyledTag = styled.div<{ flagged?: boolean }>`
  ${baseTagStyles}
  background-color: ${palettes.brand.red.lightest};
  color: ${({ flagged }) => getTagColor(flagged)};
  border: 1px solid ${({ flagged }) => getTagColor(flagged)};
`;

interface CreditConditionalTagProps {
  conditional: string;
  dismissible?: boolean;
  onDismiss?: () => void;
  flagged?: boolean;
}

const CreditConditionalTag = ({ conditional, dismissible, onDismiss, flagged }: CreditConditionalTagProps) => {
  return (
    <WithConditionalTooltip visible={flagged} title="Condicional adicionado em outra negociação" placement="top-start">
      <StyledTag flagged={flagged}>
        {getConditionalText(conditional)}
        {dismissible && <TagCloseButton type="conditional" onClick={onDismiss} />}
      </StyledTag>
    </WithConditionalTooltip>
  );
};

export default CreditConditionalTag;
